if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector;
}
//# sourceMappingURL=Element.matches.js.map